module.exports = __webpack_public_path__ + "img/bos.cf1babae.jpg";